export default {"src":"/_next/static/media/email.9cd7daf6.svg","height":138,"width":169,"blurWidth":0,"blurHeight":0};